import { PartnerPermission, PartnerRole } from '@atlassian/mpac-api-client';
export const partnerPermissionLabels = [{
  label: 'Manage vendor details',
  value: PartnerPermission.managePartnerDetails
}, {
  label: 'Manage partner payment details',
  value: PartnerPermission.managePayment
}, {
  label: 'Manage app details',
  value: PartnerPermission.manageAppDetails
}, {
  label: 'Manage app pricing',
  value: PartnerPermission.manageAppPricing
}, {
  label: 'Manage promotions',
  value: PartnerPermission.managePromotions
}, {
  label: 'View sales reports',
  value: PartnerPermission.viewSaleReports
}, {
  label: 'View all other reports',
  value: PartnerPermission.viewUsageReports
}];
export const partnerRoleLabels = {
  [PartnerRole.primary]: 'Primary',
  [PartnerRole.support]: 'Support',
  [PartnerRole.finance]: 'Licensing/Finance',
  [PartnerRole.security]: 'Security',
  [PartnerRole.marketing]: 'Marketing',
  [PartnerRole.engineering]: 'Engineering',
  [PartnerRole.migrations]: 'Migrations'
};
export const partnerRoleOptions = Object.keys(PartnerRole).filter(role => role !== PartnerRole.primary).map(role => ({
  label: partnerRoleLabels[role],
  value: role
}));
export const ADD_CONTACT_FAILED = 'Unable to add contact';
export const MANAGE_CONTACT_FAILED = 'Unable to edit contact';
export const ADD_CONTACT_SUCCESS = "You've successfully added a new contact";
export const MANAGE_CONTACT_SUCCESS = "You've successfully edited a contact";
export const ADD_CONTACT_SUCCESS_DESCRIPTION = 'has been added to partner contacts.';
export const MANAGE_CONTACT_SUCCESS_DESCRIPTION = 'Your partner contact edits have been saved.';
export const UNKNOWN_USER = "We couldn't add your contact due to the email address does not match any known user.";
export const EXISTING_USER = "We couldn't add your contact due to the email address is already a contact for the partner.";